import React from "react";

import Api from "js/core/api";
import { withFirebaseUser } from "js/react/views/Auth/FirebaseUserContext";

export const Experiment = withFirebaseUser(class ExperimentImpl extends React.Component {
    state = {
        loading: true
    };

    async componentDidMount() {
        try {
            // API call will enroll user in experiment on-the-fly if necessary
            const res = await Api.experiments.post({ id: this.props.id });
            console.log("[experiment]", res);
            this.setState({ loading: false, enabled: res.enabled });
        } catch (err) {
            // failsafe
            console.warn(err);
            this.setState({ loading: false, enabled: false });
        }
    }

    render() {
        if (this.state.loading) {
            return null;
        } else {
            return this.props.children(this.state.enabled);
        }
    }
});
